/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';
import createRoute from '../create-route';

const superior_routes = createRoute({
  component: Layout,
  redirect: {
    name: 'optimize',
  },
  name: 'superior',
  alwaysShow: true,
  meta: {
    title: '体验版',
    permissions: 'superior',
    icon: 'ali-optimization',
  },
  children: [
    // 今日头条体验版
    {
      component: () => import('@/views/superior/jrtt/'),
      name: 'superiorJrtt',
      meta: {
        title: '今日头条-体验版',
        permissions: 'superior-jrtt',
      },
      children: [
        {
          component: () => import('@/views/superior/jrtt/project-manage/'),
          name: 'projectManage',
          meta: {
            title: '项目管理',
            permissions: 'project-manage',
          },
        },
        {
          component: () => import('@/views/superior/jrtt/ad-manage/'),
          name: 'adManage',
          meta: {
            title: '广告管理',
            permissions: 'ad-manage',
          },
        },
        {
          component: () => import('@/views/superior/jrtt/'),
          name: 'report',
          meta: {
            title: '报表分析',
            permissions: 'jrtt-superior-report',
          },
          children: [
            {
              component: () => import('@/views/superior/jrtt/report/project-report'),
              name: 'projectReport',
              meta: {
                title: '项目报表',
                permissions: 'jrtt-superior-project-report',
              },
            },
            {
              component: () => import('@/views/superior/jrtt/report/ad-report'),
              name: 'adReport',
              meta: {
                title: '广告报表',
                permissions: 'jrtt-superior-ad-report',
              },
            },
            {
              component: () => import('@/views/superior/jrtt/report/material-report'),
              name: 'materialReport',
              meta: {
                title: '素材报表',
                permissions: 'jrtt-superior-material-report',
              },
            },
          ],
        },
        {
          component: () => import('@/views/superior/jrtt/intelligence-create-plan/'),
          name: 'intelligenceCreatePlan',
          meta: {
            title: '智能创建计划',
            permissions: 'intelligence-create-plan',
          },
          hidden: true,
        },
      ],
    },
  ],
});

export default superior_routes;
